import { REGULAR_TRANSLATIONS } from '~shared/constants/translations.constant';

export const CREATE_ADDRESS_ACTION_LIST = [
  {
    type: 'submit',
    text: REGULAR_TRANSLATIONS.save,
  },
];
